export type Segment = "monthly_3mo" | "6mo_12mo";

export const segments: Segment[] = ["monthly_3mo", "6mo_12mo"];

export const selectSegments = segments.map((segment) => ({
  value: segment,
  label: segment === "monthly_3mo" ? "Monthly / 3-Month" : "6-Month / 12-Month",
}));

export const colorsBySegment: Record<Segment, string> = {
  monthly_3mo: "blue",
  "6mo_12mo": "teal",
};
